import { getMomentTz } from "@dexteel/mesf-core";
import SyncIcon from "@mui/icons-material/Sync";
import { Box, Skeleton, Typography } from "@mui/material";
import { CheckboxTextField } from "@/controls/CheckboxTextField";
import type { DayShiftOption } from "@/shared/repositories/LineScheduleRepository";

const moment = getMomentTz();

const fmt = (utc: string) => moment(moment.utc(utc).toDate()).format("HH:mm");

type Props = {
	options: DayShiftOption[] | undefined;
	loading: boolean;
	disabled?: boolean;
	pending: Map<number, boolean>;
	onToggle: (shiftId: number, isSpell: boolean) => void;
};

export const ShiftSpellToggles = ({
	options,
	loading,
	disabled = false,
	pending,
	onToggle,
}: Props) => (
	<>
		<Typography
			variant="body2"
			color="text.secondary"
			sx={{ mt: 2.5, mb: 1, display: "flex", alignItems: "center", gap: 0.5 }}
		>
			<SyncIcon sx={{ fontSize: "1rem" }} />
			Spell per shift — crew rotates breaks, the line keeps running
		</Typography>
		<Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
			{loading || !options ? (
				[0, 1, 2].map((i) => <Skeleton key={i} variant="rounded" height={40} />)
			) : !options.length ? (
				<Typography variant="body2" color="text.secondary">
					No shifts available for this day
				</Typography>
			) : (
				options.map((shift) => {
					const count = shift.BreakCount
						? `${shift.BreakCount} break${shift.BreakCount > 1 ? "s" : ""}`
						: "no breaks scheduled";
					const saved =
						shift.BreakCount > 0 && shift.SpellCount === shift.BreakCount;
					const spellCount = pending.has(shift.ShiftId)
						? pending.get(shift.ShiftId)
							? shift.BreakCount
							: 0
						: shift.SpellCount;
					const mixed =
						spellCount > 0 && spellCount < shift.BreakCount
							? ` · ${spellCount} of ${shift.BreakCount} spell`
							: "";
					return (
						<CheckboxTextField
							key={shift.ShiftId}
							label={`${shift.Shift}  ${fmt(shift.Start)} → ${fmt(shift.End)} · ${count}${mixed}`}
							checked={pending.get(shift.ShiftId) ?? saved}
							disabled={disabled || shift.BreakCount === 0}
							onChange={(checked) => onToggle(shift.ShiftId, checked)}
						/>
					);
				})
			)}
		</Box>
	</>
);
